const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);

export const IS_MOBILE_APP = (urlParams.get('mobileapp') ?? '') === 'true';
